import { Button, Modal } from "@findemdev/maui";

interface IUnshareListModalProps {
  open: boolean;
  isLoading: boolean;
  onStopSharing: () => void;
  onClose: () => void;
}

const UnshareListModal = ({
  open,
  isLoading,
  onStopSharing,
  onClose,
}: IUnshareListModalProps) => {
  return (
    <Modal
      open={open}
      onCancel={onClose}
      title="Stop sharing this list with your team?"
      footer={[
        <Button key="close" onClick={onClose} disabled={isLoading}>
          Close
        </Button>,
        <Button
          key="stop-sharing"
          type="primary"
          onClick={onStopSharing}
          loading={isLoading}
        >
          Stop sharing with team
        </Button>,
      ]}
    >
      <p style={{ marginBottom: 16 }}>This means:</p>
      <ul style={{ paddingLeft: 21, margin: 0, listStyleType: "disc" }}>
        <li>Your team will no longer have access</li>
        <li>The list will only be available to you in Company Research</li>
        <li>Seeing contacts at these companies will no longer be available</li>
        <li>The Ask for intros link will stop working (if enabled)</li>
      </ul>
    </Modal>
  );
};

export default UnshareListModal;
